import { ChannelProvider } from "ably/react";
import DashboardSidebar from "components/common/DashboardSidebar";
import DashboardNav from "components/common/Navbar/DashboardNav";
import useGetUserFlowMode from "hooks/Flow/useGetUserFlowMode";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { authActions } from "redux/Ldb/actions";

type DashboardFrameProps = {
    children: React.ReactNode;
};

const DashboardFrame = ({ children }: DashboardFrameProps) => {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const { mode } = useGetUserFlowMode();
    const pathname = useLocation().pathname;
    const handleResize = () => {
        const windowWidth = window.innerWidth;

        setSidebarCollapsed(windowWidth <= 1024);
    };

    useEffect(() => {
        handleResize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div className="bg-body-1 w-full min-h-screen overflow-x-hidden">
            <ChannelProvider channelName={`data-sync`}>
                <ChannelProvider channelName={`sales-data-sync`}>
                    <ChannelProvider channelName={`campaign-data-sync`}>
                        <ChannelProvider channelName={`forecast`}>
                            {mode === "flow" && pathname.startsWith("/dashboard/home") ? null : (
                                <DashboardNav setSidebarCollapsed={setSidebarCollapsed} />
                            )}
                        </ChannelProvider>
                    </ChannelProvider>
                </ChannelProvider>
            </ChannelProvider>

            <div
                className={`flex w-full ${
                    mode === "flow" && pathname.startsWith("/dashboard/home")
                        ? "bg-gradient-to-b from-[#BCF4CD] via-[#E7FBBE] to-[#FFFDF8] h-[100vh] p-8"
                        : "h-[calc(100vh-84px)] max-lg:h-[calc(100vh-129px)]"
                } `}
            >
                {/* <div className={`${!sidebarCollapsed && "w-[22%]"}`}>
                    <DashboardSidebar
                        setSidebarCollapsed={setSidebarCollapsed}
                        sidebarCollapsed={sidebarCollapsed}
                    />
                </div> */}

                <div
                    id="dashboardContent"
                    className={`${
                        mode === "flow" && pathname.startsWith("/dashboard/home")
                            ? "!overflow-hidden w-full h-full !overflow-y-hidden border bg-white border-slate-100 rounded-xl p-3"
                            : "bg-white  custom-y-scrollbar pt-[17px] pb-6 lg:px-[47px] px-5  w-full  overflow-y-scroll"
                    }  `}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

export default DashboardFrame;
